import { BiUser } from "react-icons/bi";

import Button from "@/components/ui/buttons/Button/Button";
import styles from "./SignUpSignInButton.module.scss";

export default function SignUpSignInButton({
  onClick,
  buttonRef,
  mode,
  children,
  className,
}) {
  if (mode === "button") {
    return (
      <div ref={buttonRef}>
        <Button
          onClick={onClick}
          classes={["sign-up-sign-in-button", className].filter(Boolean)}
        >
          {children ?? "Sign Up/Sign In"}
        </Button>
      </div>
    );
  }

  if (mode === "buttons") {
    return (
      <div ref={buttonRef} className={`${styles.buttons}`}>
        <Button
          onClick={(event) => onClick(event, "signUp")}
          classes={["sign-up-sign-in-button", className].filter(Boolean)}
          fill="transparentBorderWhite"
        >
          Sign Up
        </Button>
        <Button
          onClick={(event) => onClick(event, "signIn")}
          classes={["sign-up-sign-in-button", className].filter(Boolean)}
        >
          Sign In
        </Button>
      </div>
    );
  }

  return (
    <button
      onClick={onClick}
      className={`${styles.userButton} ${styles.custom} sign-up-sign-in-button ${
        className ?? ""
      }`}
      ref={buttonRef}
    >
      {children ?? <BiUser size={27} color="white" />}
    </button>
  );
}
